import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';
import {
	SyncMortgagesPackagesState,
	SyncMortgagesPackagesStateModel,
} from './sync-mortgages-packages.state';
import {
	SyncMortgagePackage,
	SyncMortgagePackageStatus,
} from '@models/mortgages/closer-sync-mortgage-packages';

@Injectable()
export class SyncMortgagesPackagesSelectors {
	@Selector([SyncMortgagesPackagesState])
	static getAllMortgagePackages(
		state: SyncMortgagesPackagesStateModel,
	): SyncMortgagePackage[] {
		return (
			state.data.filter((mortgagePackage) => !mortgagePackage.deletedAt) ?? []
		);
	}

	@Selector([SyncMortgagesPackagesState])
	static getAllDeletedMortgagePackages(
		state: SyncMortgagesPackagesStateModel,
	): SyncMortgagePackage[] {
		return (
			state.data.filter((mortgagePackage) => mortgagePackage.deletedAt) ?? []
		);
	}

	@Selector([SyncMortgagesPackagesSelectors.getAllMortgagePackages])
	static getAllPendingPackages(
		packages: SyncMortgagePackage[],
	): SyncMortgagePackage[] {
		return packages.filter(
			(pkg: SyncMortgagePackage) =>
				pkg.status === SyncMortgagePackageStatus.PENDING,
		);
	}

	@Selector([SyncMortgagesPackagesSelectors.getAllMortgagePackages])
	static getAllGeneratedPackages(
		packages: SyncMortgagePackage[],
	): SyncMortgagePackage[] {
		return packages.filter(
			(pkg: SyncMortgagePackage) =>
				pkg.status === SyncMortgagePackageStatus.GENERATED,
		);
	}
}
